import Playlist from 'components/shared/Playlist'
import React from 'react'
// import Experts from 'components/shared/Experts';
import PlaylistFollowing from 'components/shared/Playlist/PlaylistFollowing';
import useIsAuth from 'sdk/hooks/useIsAuth';
import styles from './CategoriesPage.module.scss';
import TopMovers from '../TopMovers';
import HashtagCollection from '../HashtagCollection';
import TopAssets from '../TopAssets';
import TopAssetsFollowing from '../TopAssets/TopAssetsFollowing';

type Props = {
  schema: any
  categoryId: string | undefined
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function RenderBySchema({ schema, categoryId }: Props) {
  const { data: isAuthData } = useIsAuth()
  const isAuth = isAuthData?.isAuth

  return (
    schema?.map((item) => {
      if (item?.type === 'post') {
        if (item?.style === 'post_following' && isAuth) {
          return (
            <PlaylistFollowing
              id={item?.playlist_id}
              userId={isAuthData.user?.id}
              activeCategoryId={categoryId}
            />
          )
        }

        return (
          <Playlist
            id={item?.playlist_id}
            activeCategoryId={categoryId}
            isDaily={item?.style === 'post_daily'}
            count={item?.item_per_row || 4}
            grid={item?.style === 'post_grid'}
          />
        )
      }
      if (item?.type === 'asset' && item?.style === 'asset_top_mover') {
        return (
          <div className={styles.topMovers}>
            <TopMovers
              collectionId={4}
              title="Top movers"
              viewAllLink="/popular-stocks"
              activeCategoryId={categoryId ? +categoryId : 0}
            />
          </div>
        )
      }
      if (item?.type === 'asset') {
        if (item.style === 'asset_by_follow') {
          return (
            <TopAssetsFollowing
              relativeActiveCategory={categoryId}
              showCategoriesSelect={false}
            />
          );
        }

        return (
          <TopAssets
            collectionId={item?.collection_id}
            relativeActiveCategory={categoryId}
            title=""
          />
        )
      }
      if (item?.type === 'tag' || item?.type === 'hashtag') {
        return (
          <HashtagCollection collectionId={item?.collection_id} />
        )
      }
      // if (item?.type === 'expert') {
      //   return <Experts collectionId={9} i
      // sNew={item?.style === 'expert_new'} mainTitle="Top Creators" />
      // }
      return <></> // eslint-disable-line
    })
  )
}
